import { AddressValue, VariableValue } from 'product_modules/api/Types';
import { CorrespondenceChecker } from 'product_modules/utils/valueVisualTypeCorrespondenceCheckers/Types';

const isCorrespondsAddress: CorrespondenceChecker<AddressValue> = (value: VariableValue): value is AddressValue => {
  return typeof value === 'object' && !Array.isArray(value);
};

export default isCorrespondsAddress;
